export default __webpack_public_path__ + "static/media/EXR_FactionIcons-02_Serf.3206725a.png";